module.exports = __webpack_public_path__ + "static/media/resources.8586c3d6.svg";